import styled from 'styled-components/macro';
import { variables } from 'theme/variables';

const {
  custom_blue: customBlue,
  color_grey_100: colorGrey100,
  color_white: colorWhite,
  color_grey_300: colorGrey300,
} = variables;

export const PipeFactsTechnicalDetails = styled('div')`
  width: 100%;
  background: ${colorGrey100};
  padding: 10px;
  border-radius: 1em;
  display: flex;
  flex-wrap: wrap;
  .titleAndTabs {
    height: 50px;
    @media (max-width: 992px) {
      display: flex;
      justify-content: center;
      font-size: 0.5rem;
      min-height: 89px;
    }
    @media (max-width: 550px) {
      min-height: 125px;
    }
    @media (max-width: 361px) {
      min-height: 165px;
    }
  }
  .tabListCol {
    padding-left: 10%;
    @media (max-width: 992px) {
      padding-left: 0;
      display: flex;
      justify-content: center;
    }
  }

  .tabs {
    @media (max-width: 550px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }
  }
  .tabData {
    position: relative;
  }
  .directionButton {
    position: absolute;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: ${colorGrey300} !important;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 4;
  }
  .directionButton:hover {
    background-color: ${customBlue} !important;
  }
  #prevTab {
    top: 250px;
    right: 95.75%;
  }
  #nextTab {
    top: 250px;
    right: 1.2%;
  }
  @media (max-width: 1330px) {
    #prevTab {
      right: 95%;
    }
  }
  @media (max-width: 1175px) {
    #prevTab {
      right: 94.6%;
    }
  }
  @media (max-width: 1024px) {
    #prevTab {
      right: 94%;
    }
    #nextTab {
      right: 1.4%;
    }
  }
  @media (max-width: 768px) {
    #prevTab {
      right: 93%;
    }
    #nextTab {
      right: 1.45%;
    }
  }
  @media (max-width: 820px) {
    .directionButton {
      height: 0;
      width: 0;
      display: none;
    }
  }
`;

export const PipeFactsSectionHeader = styled('h2')`
  margin-bottom: 0;
  margin-top: 10px;
  padding-top: 10px;
  font-size: 1.8rem;
  font-weight: 500;
  color: #76899e;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  white-space: nowrap;
  min-width: 0;
  color: ${customBlue};
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 992px) {
    justify-content: center;
    flex-direction: row;
  }
  @media (max-width: 425px) {
    align-items: center;
    font-size: 1.5rem;
  }
`;

export const PipeFactsTechnicalDetailsTab = styled.div`
  margin-top: 10px;
  background: ${colorWhite};
  border-radius: 1.5em;
  width: 100%;
  box-shadow: 0 4px 16px #c0cff7;
  margin-left: 10px;
  margin-right: 10px;
  min-height: 400px;
  @media (max-width: 425px) {
    margin-left: 0px;
    margin-right: 0px;
  }
`;

export const InfoTab = styled.div`
  background-image: ${(props) => props.backgroundImage || 'none'};
  background-repeat: ${(props) =>
    props.backgroundImage ? 'no-repeat' : 'none'};
  background-position: ${(props) => props.backgroundPosition || 'none'};
  background-size: ${(props) => props.backgroundSize || '0'};
  padding: 10px;
  min-height: 500px;
  .qualityScope {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 20px;
    min-height: 500px;
  }
  .pipeFactsDescription {
    margin-top: 5px;
  }
  .learnMoreLink,
  .learnMoreLink_Default {
    display: flex;
    justify-content: center;
    position: relative;
    top: 14px;
    margin-left: 5px;
  }
  #inspectionMetricsHeader {
    min-height: 60px;
    height: 5%;
    margin-bottom: 20px;
    justify-content: center;
  }
  @media (max-width: 1296px) {
    .learnMoreLink {
      height: 20px;
    }
  }
  @media (max-width: 1260px) {
    .pipeFactsDescription {
      max-height: 250px;
      overflow: auto;
    }
  }
  @media (max-width: 991px) {
    .qualityTracker {
      width: 30%;
    }
  }
  @media (max-width: 983px) {
    .pipeFactsDescription {
      max-height: 150px;
    }
  }
  @media (max-width: 860px) {
    .pipeFactsDescription {
      margin-left: 10px;
    }
  }
  @media (max-width: 780px) {
    .qualityInfo {
      display: flex;
      flex-flow: column wrap;
    }
    .qualityTracker {
      width: 100%;
    }
    .qualityDetails {
      width: 100%;
    }
    .pipeFactsDescription {
      max-height: 225px;
    }
    #inspectionMetricsRow {
      height: -webkit-fill-available;
    }
  }
  @media (max-width: 768px) {
    background-image: none;
    .qualityDetails {
      padding-right: 15px;
    }
  }
  @media (max-width: 661px) {
    height: ${(props) => (props.tab === 'sizeAndStrength' ? '650px' : '100%')};
  }
  @media (max-width: 480px) {
    height: ${(props) => (props.tab === 'sizeAndStrength' ? '750px' : '100%')};
  }
`;

export const PipeFactsSectionHeaders = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  padding-top: 15px;
  display: flex;
  text-align: center;
  @media (max-width: 860px) {
    margin-left: 10px;
  }
  @media (max-width: 425px) {
    font-size: 1.3rem;
    flex-wrap: wrap;
  }
`;

export const PipeFactsStatus = styled.div`
  display: flex;
  background: ${colorGrey100};
  justify-content: center;
  border-radius: 0.5em;
  height: 100%;
`;
